export default __webpack_public_path__ + "static/media/tvs-king.15bbea74.svg";